const Footer = () => {
    return(
        <>
        <div className="container-fluid bg-dark text-light footer pt-5 mt-5 wow fadeIn" data-wow-delay="0.1s">
        <div className="container py-5">
            <div className="row g-5">
               <div className="col-lg-3 col-md-6">
    <h4 className="text-light mb-4">Address</h4>
    <p className="mb-2"><i className="fa fa-map-marker-alt me-3"></i>#327, Vasantha Complex, Opposite to Raghavendra Mutt, Narayan Shastri Road, Mysore, Karnataka, India</p>
    <p className="mb-2"><i className="fa fa-phone-alt me-3"></i>Support : 0821-4246005</p>
    <p className="mb-2"><i className="fa fa-mobile-alt me-3"></i>Direct : 9886295510</p>
<p className="mb-2">
    <i className="fa fa-envelope me-3"></i>
    <a href="mailto:info@a2zsolutionsindia.co.in">info@a2zsolutionsindia.co.in</a>
</p>    
    
            {/* Social Media Icons */}
            <div className="d-flex pt-2">
                <a 
                    href="https://www.facebook.com/profile.php?id=61585761711681" 
                    className="btn btn-outline-light btn-social me-2"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Facebook"
                >
                    <i className="fab fa-facebook-f"></i>
                </a>
                <a 
                    href="https://www.linkedin.com/in/a2z-solutions-india-a221003a2" 
                    className="btn btn-outline-light btn-social me-2"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="LinkedIn"
                >
                    <i className="fab fa-linkedin-in"></i>
                </a>
                <a 
                    href="https://www.instagram.com/a2z_your_solutions" 
                    className="btn btn-outline-light btn-social me-2"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                >
                    <i className="fab fa-instagram"></i>
                </a>
                <a 
                    href="https://x.com/A2Z_SolutionsIN" 
                    className="btn btn-outline-light btn-social me-2"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Twitter/X"
                >
                    <i className="fab fa-twitter"></i>
                </a>
                {/* <a 
                    href="https://www.youtube.com/@a2zsolutionsmysuru" 
                    className="btn btn-outline-light btn-social"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="YouTube"
                >
                    <i className="fab fa-youtube"></i>
                </a> */}
            </div>
        </div>
                <div className="col-lg-3 col-md-6">
                    <h4 className="text-light mb-4">Quick Links</h4>
                    <a className="btn btn-link" href="/about">About Us</a>
                    <a className="btn btn-link" href="/contact">Contact Us</a>
                    <a className="btn btn-link" href="/service">Our Services</a>
                    <a className="btn btn-link" href="/">Privacy Policy</a>
                    <a className="btn btn-link" href="/">Terms & Conditions</a>
                </div>
                <div className="col-lg-3 col-md-6">
                    <h4 className="text-light mb-4">Our Services</h4>
                    <a className="btn btn-link" href="/academic">Academic Education</a>
                    <a className="btn btn-link" href="/med">Medical Billing</a>
                    <a className="btn btn-link" href="/data">Annotation & Data Entry Services</a>
                    <a className="btn btn-link" href="/web">Web Development</a>
                    <a className="btn btn-link" href="/training">Training Services</a>
                    <a className="btn btn-link" href="/man">Man Power Services</a>
                    <a className="btn btn-link" href="/hardware">Computer Hardware</a>
                </div>
                <div className="col-lg-3 col-md-6">
                    <h4 className="text-light mb-4">Business Hours</h4>
                    <p className="mb-1">Monday - Friday</p>
                    <h6 className="text-light">9:00 AM - 7:00 PM</h6>
                    <p className="mb-1">Saturday</p>
                    <h6 className="text-light">9:00 AM - 2:00 PM</h6>
                    <p className="mb-1">Sunday</p>
                    <h6 className="text-light">Emergency Support Only</h6>
                </div>
            </div>
        </div>
        <div className="container">
            <div className="copyright">
                <div className="row">
                    <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                        &copy; <a className="border-bottom" href="#">2026, A2Z Solutions</a>, All Rights Reserved.
                    </div>
                    <div className="col-md-6 text-center text-md-end">
                        Web-Powered by <a className="border-bottom" href="https://www.vssitcompany.com/" target="_blank" rel="noopener noreferrer">Veriteam Software Solutions</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
        </>
    )
}
export default Footer;

 